export const canine = [
  { id: '2665', description: 'Canine Cardiopet® proBNP Test' },
  { id: '2625', description: 'Canine Comprehensive Diarrhea RealPCR™ Panel' },
  {
    id: '2524',
    description: 'Canine Comprehensive Respiratory RealPCR™ Panel',
  },
  { id: '1849', description: 'Spec cPL® Test' },
];
